fx.ns("filters", class StickerFilter extends fx.Filter {

	constructor(creation)
	{
        super();

        this._search = "";
        this._creation = creation;
    }


    get search()
    {
        return this._search;
    }

    set search(val)
    {
        this._search = val;
    }

   
	exec()
	{
        if (!this.rawData)
            return;

        let adminMode = fx.get("app") == "config";

        this.transformedData = [];
        let projectTagAdded = false,
            searchTagAdded = false;
        let themeCategoryTagAdded = false;
        let stickersUsed = [];
        let stickerCollection = [];

        let displayLabels = !(this._creation && this._creation.useMedias);

        
        for (let i = 0; i < this.rawData.length; i++)
        {
            let sticker = this.rawData.getItemAt( [i] );

            if (this.search != "")
            {
                if (!searchTagAdded)
                {
                    this.transformedData.push( {type : "label", text : fx.text('Recherche') + ' : "' + this.search + '"'}  );
                    searchTagAdded = true;
                }
                
                if (sticker.visible || (sticker.available && sticker.removable) || adminMode)
                    this.transformedData.push( sticker );
            }
            else
            {
                if ( sticker.number > 0)
                {
                    if (!projectTagAdded && displayLabels)
                    {
                        stickersUsed.push( {type : "label", text : fx.text("Stickers utilisés")}  );
                        projectTagAdded = true;
                    }

                    if (sticker.visible || (sticker.available && sticker.removable) || adminMode)
                        stickersUsed.push( sticker );
                }
                else
                {
                    if (!themeCategoryTagAdded && displayLabels)
                    {
                        stickerCollection.push( {type : "label", text : fx.text("Stickers recommandés")}  );
                        themeCategoryTagAdded = true;
                    }

                    if ((sticker.visible || this._creation.useMedias || (sticker.available && sticker.removable) || adminMode) && !stickerCollection.find({id : sticker.id}))
                        stickerCollection.push( sticker );
                }

            }
            
            
        }

        if (this.search == "")
        //{
            //if (stickerCollection.length > 0)
                this.transformedData = stickersUsed.concat(stickerCollection);
          //  else
            //    this.transformedData = stickersUsed;
        //}

        if (this.search != "" && this.transformedData.length == 0)      
            this.transformedData.push( {type : "label", text : fx.text('Aucun résultat pour') + ' "' + this.search + '"'}  );

        this.transformedData.more = this.rawData.more;

		return this.transformedData;
	}	
});